export const API_URL = "https://sudarshan.fonetricks.com"
export const SOCKET_URL = "https://sudarshan.fonetricks.com"
